/**
 @ngdoc directive
 @name refreshStatusView

 @description
 Add asynchronous conditionality to elements<br />
 <code>ng-if="$parent.conditionChanged"</code> adds element to DOM when {url} returns status: true<br />
 <code>ng-if</code> creates new scope so <code>$parent</code> must be used<br />
 Based on refreshStatus<br />

 @param {url} url URL to collect latest JSON information about the Status
 @param {integer=} refresh-status-attempts number attempts to refresh the status
 @param {integer=} refresh-status-interval number of seconds before next attempt

 @examples
  <refresh-status-view url="${g.createLink(controller:'candidate', action:'cvParsingState', id: candidateInstance.id)}">
    <div class="alert alert-warning" role="alert" aria-live="assertive" ng-if="!$parent.conditionChanged">
        <i class="loading-spinner link-spinner"></i><strong>Please wait</strong> This record will be updated shortly once the CV has completed parsing.<br />
    </div>
    <div class="alert alert-success" role="success" aria-live="assertive" ng-if="$parent.conditionChanged">
        <strong>CV completed Parsing</strong> <a href="${g.createLink(controller: 'candidate', action: 'edit', id: candidateInstance.id)}">Click here to refresh the page - please refresh before manually adding information as this may otherwise be erased</a><br />
    </div>
 </refresh-status-view>

 */
(function() {
    'use strict';
    var refreshStatusView = function($templateCache, $http, $interval) {
        return {
            restrict: 'EA',
            template: "<ng-transclude></ng-transclude>",
            replace: false,
            transclude: true,
            scope: true,
            bindToController: {
                ajaxUrl: '@url',
                numberOfAttempts: '@refreshStatusAttempts',
                intervalInSeconds: '@refreshStatusInterval'
            },
            controllerAs: "ctrl",
            controller: ['$scope', function($scope){
                var _this = this;
                _this.$onInit = function(){

                    $scope.conditionChanged = false;
                    $scope.watchedVariable = null;
                    $scope.ajaxUrl = _this.ajaxUrl;

                    $scope.milliseconds = 3000; // default
                    if(angular.isDefined(_this.intervalInSeconds)){
                        $scope.milliseconds = _this.intervalInSeconds * 1000;
                    }

                    $scope.numberOfAttempts = 100; // default
                    if(angular.isDefined(_this.numberOfAttempts)){
                        $scope.numberOfAttempts = _this.numberOfAttempts;
                    }
                };

                var refreshStatusId;
                var attemptNumber = 0;

                var stopRefresh = function(){
                    $interval.cancel(refreshStatusId);
                };

                var updateStatus = function(data){
                  $scope.conditionChanged = false;
                  var areVariablesEqual = false;

                  if($scope.watchedVariable) {
                    var swvKeys = Object.keys($scope.watchedVariable);
                    var dwvKeys = Object.keys(data.watchedVariable);
                    areVariablesEqual = $scope.watchedVariable[swvKeys] === data.watchedVariable[dwvKeys];
                  }

                  if((data.status && data.status.changed == true) || !areVariablesEqual){
                    $scope.conditionChanged = true;
                    $scope.watchedVariable = data.watchedVariable;
                    stopRefresh();
                  }
                };

                var getStatus = function(){
                    $http.get($scope.ajaxUrl)
                        .then(function(response){
                                updateStatus(response.data);
                            }, function(response){
                                // error handling
                            }
                        );
                };

                var checkStatus = function(){
                    attemptNumber++;

                    if(attemptNumber <= $scope.numberOfAttempts){
                        getStatus();
                    } else {
                        stopRefresh();
                    }
                };

                angular.element(document).ready(function () {
                    // Start the refresh status process. Save the refreshStatusId for canceling
                    refreshStatusId = $interval(function(){
                        checkStatus();
                    }, $scope.milliseconds);
                });

            }],
            require: ['refreshStatusView']
        };
    };
    refreshStatusView.$inject = ['$templateCache', '$http', '$interval'];
    angular.module('app').directive('refreshStatusView', refreshStatusView);
}());
